import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import type { AppView } from '../../types/views';

interface BreadcrumbsProps {
  activeView: AppView;
}

const viewLabels: Record<AppView, string> = {
  dashboard: 'Dashboard',
  certificates: 'Certificate Generation',
  clients: 'Client Management', 
  reminders: 'Certificate Reminders',
  reviews: 'Review Management',
  bookings: 'Booking Management',
  ops: 'Ops Day Planner',
  quotes: 'Quote Management',
  financial: 'Financial Reports',
  emails: 'Comms',
  tasks: 'Tasks',
  admin: 'Admin',
  superadmin: 'Super Admin',
  faq: 'Help & FAQ',
  'process-numbers': 'Process Numbers / Safe Pass Cards',
  'owner-analytics': 'Admin Efficiency Dashboard',
};

const viewDescriptions: Record<AppView, string> = {
  dashboard: 'Business overview and quick actions',
  certificates: 'Upload data and generate certificates',
  clients: 'Manage customers, locations, and contacts',
  reminders: 'Track certificate expiry dates and renewals',
  reviews: 'Manage client review requests and feedback',
  bookings: 'Schedule and manage training bookings',
  ops: "Today's sessions and operational risks at a glance",
  quotes: 'Create, send, and accept quotes',
  financial: 'Revenue tracking and profit analysis',
  emails: 'Comms and engagement dashboard',
  tasks: 'Task and reminder management',
  admin: 'Administration panel for instructors and emails',
  superadmin: 'System administration and user management',
  faq: 'Frequently asked questions and support',
  'process-numbers': 'Centralised Safe Pass process numbers and card distribution',
  'owner-analytics': 'Monitor admin throughput, SLA, quality, and business outcomes',
};

export function Breadcrumbs({ activeView }: BreadcrumbsProps) {
  return (
    <nav className="flex items-center space-x-2 text-sm">
      <div className="flex items-center space-x-2 muted hover-lift">
        <Home className="w-4 h-4 icon-enhanced" />
        <span className="gradient-text-primary font-medium">Rapid Cert</span>
      </div>
      
      <ChevronRight className="w-4 h-4 muted" />
      
      <div className="flex flex-col">
        <span className="font-medium text-[rgb(var(--text-emphasis))] gradient-text-primary">
          {viewLabels[activeView]}
        </span>
        <span className="text-xs muted hidden sm:block">
          {viewDescriptions[activeView]}
        </span>
      </div>
    </nav>
  );
}